import React from 'react'
import { Container } from '@material-ui/core';

const BienveunMessage = () => {
    return (
        <Container className="p-5" >
            <h1>Welcome</h1>
            <p>Select a city in the search bar</p>
      </Container>
    )
}

export default BienveunMessage